<template >
  <div style="background-color: white!important;min-height:800px!important">
    <section v-if="shw == 1">
      <div class="row pt-4" style="width:100%">
        <div class="col-lg-6 mx-auto">
          <img
            src="../../assets/kurmalogo.jpg"
            style="position: relative; display: inline-block; left: 50%; transform: translate(-50%);"
            width="90%"
            height="auto"
          />

          <div class="mt-4">
            <button @click="logshw()" class="btn btn-dark btn-lg btn-block">Login</button>
          </div>
        </div>
      </div>
    </section>
    <section v-else-if="shw == 0" style="padding-top:100px;">
      <div class="wrapper d-flex align-items-center">
        <div class="row w-100">
          <div class="col-lg-6 mx-auto card" style="background-color:#626364!important">
            <div class="text-left p-5">
              <h2 class="text-white">Login</h2>
              <h4 class="font-weight-light text-white">Hello! let's get started</h4>
              <!-- <div v-if="err">
            <div>
              <b-alert show :duration="duration">{{err}}</b-alert>
            </div>
              </div>-->
              <h6 v-if="status==false" class="pt-2" style="color:white">{{msg}}</h6>
              <form class="pt-3" @submit="onSubmit">
                <div class="form-group">
                  <label for="exampleInputEmail1" class="text-white">Username</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="username"
                    required
                    placeholder="Username"
                  />
                  <i class="fa fa-user i1 text-white"></i>
                </div>
                <div class="form-group">
                  <label for="exampleInputPassword1" class="text-white">Password</label>
                  <input
                    type="password"
                    class="form-control"
                    id="exampleInputPassword1"
                    placeholder="Password"
                    v-model="password"
                  />
                  <i class="fa fa-lock i2 text-white"></i>
                </div>
                <div class="mt-5">
                  <!-- <a class="btn btn-block btn-warning btn-lg font-weight-medium" href="../../index.html">Login</a> -->
                  <button type="submit" class="btn btn-success btn-lg btn-block text-white">Sign In</button>
                </div>
                <div class="mt-3 text-center">
                  <a href="#" class="auth-link text-white">Forgot password?</a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import store from "../../store";
export default {
  name: "login",
  data() {
    return {
      login: {},
      username: "",
      password: "",
      errors: [],
      duration: 200,
      msg: "",
      loading: false,
      shw: 1,
      status: "",
    };
  },
  methods: {
    logshw() {
      this.shw = 0;
    },
    onSubmit(evt) {
      var data = {};
      data["username"] = this.username;
      data["password"] = this.password;

      // console.log(this.data)
      evt.preventDefault();
      axios({
        method: "POST",
        url: "/user/login",
        data: data,
    
      })
        .then((response) => {
          this.visible = false;
          this.status = response.data.status;
          this.msg = response.data.msg;

          if (this.status === true) {
            store.commit("loginUser");
            localStorage.setItem("token", response.data.data.token);
            localStorage.setItem("username", response.data.data.username);
            localStorage.setItem("type", response.data.data.admin);
            localStorage.setItem("ownerid", response.data.data.id);
            localStorage.setItem("owneremail", response.data.data.email);
            localStorage.setItem("ownerphone", response.data.data.phone);
            // localStorage.setItem("email", response.data.data.email);

            this.$router.push({ path: "/dashboard" });
            // window.location.reload()
          } else {
            // this.msg = "Username/Password is incorrect";
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          alert("Something went Wrong on Our Side");
        });
    },
  },
};
</script>
<style scoped>
body {
  background-color: #f6f8fa;
}

.form-control {
  background: transparent !important;
  border-top: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  border-radius: 0 !important;
  padding-left: 0;
  padding-right: 2.5rem;
  font-size: 0.9375rem;
  color: white !important;
}

.i1 {
  position: absolute;
  right: 4rem;
  height: 18px;
  top: calc((100% - 80px) / 2);
}

.i2 {
  position: absolute;
  right: 4rem;
  height: 18px;
  top: calc((100% - 60px) / 1.5);
}

.form-control {
  border-color: hsla(0, 0%, 100%, 0.2);
  color: #fff;
}
</style>